<template>
  <v-app>
    <v-main>
      <PreviewScriptDialog />
      <LoadCallDialog />
      <router-view />
      <SnackBar />
    </v-main>
  </v-app>
</template>

<script>
import SnackBar from '@/components//Widgets/SnackBar'
import PreviewScriptDialog from '@/components/Dialogs/PreviewScriptDialog'
import LoadCallDialog from '@/components/Dialogs/LoadCallDialog'

export default {
  name: 'App',
  components: { SnackBar, PreviewScriptDialog, LoadCallDialog },
  mounted() {
    if (window.parent === window) return
    const post = () => window.parent.postMessage({ type: 'asiabots-resize', height: document.documentElement.scrollHeight }, '*')
    post()
    new ResizeObserver(post).observe(document.documentElement)
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(post)
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

:root {
  --vb-bg: #ffffff;
  --vb-ink: #18181b;
  --vb-ink-2: #3f3f46;
  --vb-muted: #71717a;
  --vb-muted-2: #a1a1aa;
  --vb-line: #eaeaec;
  --vb-line-2: #f1f1f3;
  --vb-surface: #fafafa;
  --vb-surface-2: #f4f4f5;
  --vb-rose-100: #ffe4e6;
  --vb-rose-200: #fecdd3;
  --vb-rose-300: #fda4af;
  --vb-rose-400: #fb7185;
  --vb-accent: #ff4d67;
  --vb-accent-soft: #ffeff1;
  --vb-accent-grad: linear-gradient(90deg, #ff7a85 0%, #ff4d67 55%, #f43f5e 100%);
  --vb-radius-card: 14px;
  --vb-radius-row: 14px;
  --vb-radius-pill: 999px;
  --vb-shadow-sm: 0 1px 2px rgba(24, 24, 27, 0.04), 0 1px 1px rgba(24, 24, 27, 0.03);
  --vb-shadow-md: 0 6px 18px -8px rgba(244, 63, 94, 0.25), 0 2px 6px rgba(24, 24, 27, 0.05);
  --vb-shadow-cta: 0 16px 36px -14px rgba(244, 63, 94, 0.55), 0 4px 12px -4px rgba(244, 63, 94, 0.35);
}

* {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

html,
body {
  background: var(--vb-bg);
  color: var(--vb-ink);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
</style>
